import React, {useState} from "react";
import {Route} from "@/routing/Router";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {useQuery} from "@tanstack/react-query";
import {api} from "@/data/api";
import DayReportPageHeading from "@widgets/reports/dayReport/heading/DayReportPageHeading";
import {formatLocalDate} from "@/utils/DateUtils";
import DayReportTable from "./table/DayReportTable";
import DayReportDayPicker from "@widgets/reports/dayReport/dayPicker/DayReportDayPicker";

type Props = {
    route: Route,
};

const DayReportOverview = ({route}: Props) => {
    const {dashboardLocation} = useRestaurant();
    const [showDatePicker, setShowDatePicker] = useState(false);
    // const [showExportModal, setShowExportModal] = useState(false);
    const [selectedDay, setSelectedDay] = useState<Date>(new Date());
    const {data, isFetching} = useQuery({
        queryKey: ["day-report", dashboardLocation.id, selectedDay.toISOString()],
        queryFn: () => api.dayReport.getDayReport(dashboardLocation.id, formatLocalDate(selectedDay)),
    });

    return (
        <>
            <DayReportPageHeading
                route={route}
                selectedDay={selectedDay}
                setShowDatePicker={setShowDatePicker}
                // setShowExportModal={setShowExportModal}
                dataLoading={isFetching}
            />

            <div className={"mt-6 md:mt-12"}>
                <DayReportTable
                    dayReport={data}
                    isFetching={isFetching}
                />
            </div>

            <DayReportDayPicker
                showDatePicker={showDatePicker}
                setShowDatePicker={setShowDatePicker}
                selectedDay={selectedDay}
                setSelectedDay={setSelectedDay}
            />

            {/*<ExportDayReportModal*/}
            {/*    selected={dateRange}*/}
            {/*    show={showExportModal}*/}
            {/*    setShow={setShowExportModal}*/}
            {/*    data={data}*/}
            {/*/>*/}
        </>
    );
};

export default DayReportOverview;